import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Ticket/TicketDetail.css";
import axios from "axios";
import { getCookie } from "../../api";
import CloseForm from "../Master/CloseForm";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import axiosInstance from "../../api";
import {
  closeConnection,
  receiveMessage,
  sendSignalRMessage,
  SignalRImpl,
} from "../../SignalRImpl";

function TicketDetail({
  ticketId,
  setshowticketdetail,
  setTicketId,
  getAllUsersByTicketId,
  setShowAssignedUsersEdit,
  setShowAssignedUsers,
  showticketdetail,
}) {
  const [ticketData, setTicketData] = useState(null);
  const textarearef = useRef();
  const nav = useNavigate();
  const [comment, setComment] = useState("");
  const [username, setusername] = useState("");
  const [commentsData, setCommentsData] = useState([]);
  const [refreshcomments, setrefreshcomments] = useState(false);
  const ticketcommentingref = useRef();
  const [loading, setloading] = useState(false);
  const [customerData, setCustomerData] = useState();
  const [receivers, setReceivers] = useState([]);
  const ws = useRef(null);
  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/TicketAccess/${ticketId}`)
      .then((res) => {
        setReceivers(res.data);
      })
      .catch(console.log);
  }, [ticketId]);

  useEffect(() => {
    const textarea = textarearef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(textarea.scrollHeight, 250)}px`;
    textarea.style.overflowY = textarea.scrollHeight > 250 ? "auto" : "hidden";
  }, [comment]);

  useEffect(() => {
    if (showticketdetail) {
      const connection = SignalRImpl();

      ws.current = connection;
      connection
        .start()
        .then(() => {
          connection.on("ReceiveMessage", (user, message) => {
            setrefreshcomments(!refreshcomments);
          });
        })
        .catch(console.log);
    }

    return () => {
      closeConnection();
    };
  }, [showticketdetail]);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Commenting/GetMessagesByTicketId/${ticketData?.id}`
      )
      .then((res) => {
        setCommentsData(res.data);
        setTimeout(() => {
          ticketcommentingref?.current?.scrollTo({
            top: ticketcommentingref?.current?.scrollHeight,
            behaviour: "smooth",
          });
        }, 500);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refreshcomments, ticketData]);

  function sendMessage() {
    if (comment === "") {
      toast.error("Please Enter Comment", {
        position: "bottom-center",
        theme: "dark",
      });
    } else {
      axiosInstance
        .post(`${process.env.REACT_APP_API_URL}/api/Commenting`, {
          TicketId: ticketData.id,
          Receivers: receivers.map((x) => x.user.userID).join(","),
          Message: comment,
        })
        .then((res) => {
          setrefreshcomments(!refreshcomments);
          setComment("");
          setTimeout(() => {
            ticketcommentingref.current.scrollTo({
              top: ticketcommentingref.current.scrollHeight,
              behaviour: "smooth",
            });
          }, 500);

          if (ws.current) {
            ws.current.invoke("SendMessage", username, "Sample Message");
          }
        })
        .catch(console.log);
    }
  }

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${encodeURIComponent(
          ticketId
        )}`
      )
      .then((res) => {
        setTicketData(res.data);
        setCustomerData(res.data.newEnquiry);
      })
      .catch(console.log);
  }, [ticketId]);

  useEffect(() => {
    const decoded = jwtDecode(getCookie("token"));
    setusername(decoded?.sub);
  }, []);

  return (
    <section className="ticket-detail">
      <main>
        <div>
          <h1>Ticket Details</h1>

          {ticketData && (
            <aside>
              <p>
                <strong>Ticket ID: </strong>
                {ticketData.seriesId}
              </p>
              <p>
                <strong>Linked to Enquiry Id: </strong>
                {ticketData.enquirySeriesId}
              </p>
              <p>
                <strong>Enquiry Type: </strong>
                {ticketData.enquiryType}
              </p>
              {ticketData.serviceDetails && (
                <>
                  <p>
                    <strong>Service Type: </strong>
                    {ticketData.serviceDetails.serviceType}
                  </p>
                  <p>
                    <strong>Remarks: </strong>
                    {ticketData.serviceDetails.remarks}
                  </p>
                  <p>
                    <strong>Due Date: </strong>
                    {new Date(ticketData.serviceDetails.dueDate).toDateString()}
                  </p>
                  <p>
                    <strong>Service Description: </strong>
                    {ticketData.serviceDetails.serviceDescription}
                  </p>
                  {ticketData.serviceDetails?.serviceType === "Paid" && (
                    <>
                      <p>
                        <strong>Bill Amount: </strong>
                        {ticketData.symbol} {ticketData.billAmount ?? "---"}
                      </p>
                      <p>
                        <strong>Due Amount: </strong>
                        {ticketData.symbol} {ticketData.dueAmount ?? "---"}
                      </p>
                    </>
                  )}
                  <p>
                    <strong>Feedback: </strong>
                    {ticketData.serviceDetails?.feedBack}
                  </p>
                </>
              )}

              <p>
                <strong>Status: </strong>
                {ticketData.status}
              </p>
              <p>
                <strong>Assigned Users: </strong>
                <a
                  href="#"
                  onClick={() => {
                    setShowAssignedUsers(true);
                    setShowAssignedUsersEdit(false);
                    setTicketId(ticketId);
                  }}
                >
                  Click Here To See Assigned Users
                </a>
              </p>
              <p>
                <strong>Company/Organization Name: </strong>
                {customerData?.customer?.orgName}
              </p>
              <p>
                <strong>
                  {customerData?.isAddressSame
                    ? "Shipping / Billing Address: "
                    : "Shipping Address: "}{" "}
                </strong>
                {customerData?.shipToAddress?.addressType},{" "}
                {customerData?.shipToAddress?.officeName ||
                  customerData?.shipToAddress?.factoryName}
                , {customerData?.shipToAddress?.address1},{" "}
                {customerData?.shipToAddress?.address2},{" "}
                {customerData?.shipToAddress?.cityObj?.name},{" "}
                {customerData?.shipToAddress?.stateObj?.name},{" "}
                {customerData?.shipToAddress?.country},{" "}
                {customerData?.shipToAddress?.pincode}
              </p>
              {customerData?.isAddressSame === false && (
                <p>
                  <strong>Billing Address: </strong>
                  {customerData?.billToAddress?.addressType},{" "}
                  {customerData?.billToAddress?.officeName ||
                    customerData?.billToAddress?.factoryName}
                  , {customerData?.billToAddress?.address1},{" "}
                  {customerData?.billToAddress?.address2},{" "}
                  {customerData?.billToAddress?.cityObj?.name},{" "}
                  {customerData?.billToAddress?.stateObj?.name},{" "}
                  {customerData?.billToAddress?.country},{" "}
                  {customerData?.billToAddress?.pincode}
                </p>
              )}
            </aside>
          )}

          <CloseForm close={setshowticketdetail} />
        </div>
        <div>
          <aside>
            <div
              className={commentsData.length > 0 && "ticket-commenting-system"}
              style={{ border: commentsData.length === 0 && 0 }}
              ref={ticketcommentingref}
            >
              {commentsData.length > 0 ? (
                commentsData.map((comment) => (
                  <blockquote
                    style={{
                      alignItems:
                        comment.username === username ? "end" : "start",
                    }}
                  >
                    <mark>
                      <b>{comment.username}</b>
                      <pre>{comment.message}</pre>
                      <small>
                        {new Date(comment.sentDateTime).toLocaleString()}
                      </small>
                    </mark>
                  </blockquote>
                ))
              ) : (
                <blockquote style={{ margin: "auto 0" }}>
                  <h2>Comments will be Shown Here</h2>
                  <i class="fa-solid fa-comment-dots fa-fade fa-3x"></i>
                </blockquote>
              )}
            </div>
          </aside>

          <blockquote>
            <textarea
              placeholder="Enter Comment"
              onChange={(e) => {
                setComment(e.target.value.slice(0, 500));
              }}
              value={comment}
              ref={textarearef}
            />
            <button onClick={() => setrefreshcomments(!refreshcomments)}>
              <i class={`fa-solid fa-rotate-right ${loading && "fa-spin"}`}></i>
            </button>
            <button onClick={sendMessage}>
              <i class="fa-solid fa-paper-plane"></i>
            </button>
          </blockquote>
        </div>
      </main>
    </section>
  );
}

export default TicketDetail;
